// Readable message from an API error (detail may be a string or {message}).
export const apiErrorMessage = (err, fallback) => {
  const d = err?.response?.data?.detail;
  if (err?.response?.status === 402) return "Hosting Live Beams is for Premium and Founding Artist members. See Membership to upgrade.";
  if (typeof d === "string") return d;
  return d?.message || fallback;
};
